// Decks in their gallery sections, the same way everywhere they're listed:
// the shared /decks page and the owner's home page.

export type Placement = { name: string; section: string; order: number | null };

/**
 * Named sections first, led by the one whose decks have the lowest order (then
 * by name); in each, decks go by their order, then name. Decks with no section
 * follow alphabetically, titled "Other decks" (no title when nothing is named).
 */
export function groupDeckSections<T>(items: T[], place: (item: T) => Placement): { title: string | null; items: T[] }[] {
  const placed = items.map((item) => ({ item, p: place(item) }));
  const byOrder = (a: (typeof placed)[number], b: (typeof placed)[number]) =>
    (a.p.order ?? Infinity) - (b.p.order ?? Infinity) || a.p.name.localeCompare(b.p.name);
  const first = (title: string) => Math.min(...placed.filter((x) => x.p.section === title).map((x) => x.p.order ?? Infinity));
  const named = [...new Set(placed.map((x) => x.p.section).filter(Boolean))].sort((a, b) => first(a) - first(b) || a.localeCompare(b));
  const rest = placed.filter((x) => !x.p.section).sort((a, b) => a.p.name.localeCompare(b.p.name));
  return [
    ...named.map((title) => ({ title, items: placed.filter((x) => x.p.section === title).sort(byOrder).map((x) => x.item) })),
    ...(rest.length ? [{ title: named.length ? 'Other decks' : null, items: rest.map((x) => x.item) }] : []),
  ];
}
